import React from "react"
import Icon from "common/components/Icon"
import { Button, Typography } from "@material-ui/core"
import arrowSrc from "../../../assets/back_arrow.svg"
import democratLogo from "../../../assets/DemocraticLogo.svg"
import republicanLogo from "../../../assets/RepublicanLogo.svg"

const SortSelector = ({ label, icon, dir, enabled, onClick }) => {
  return (
    <Button onClick={onClick} style={{ display: "flex", alignItems: "center" }}>
      <Icon
        src={arrowSrc}
        height={16}
        width={16}
        style={{
          visibility: enabled ? "visible" : "hidden",
          transform: `rotate(${dir === "DESC" ? -90 : 90}deg)`,
          transition: `transform 150ms cubic-bezier(0.4, 0.0, 0.2, 1)`,
        }}
      />
      <Icon src={icon} height={16} style={{ height: 16 }} />{" "}
      <Typography style={{ fontSize: 14, fontWeight: 700 }}>{label}</Typography>
    </Button>
  )
}

const SortBar = ({ sort, onClick }) => {
  const handleClick = party => evt => {
    if (onClick) {
      onClick(party, evt)
    }
  }

  return (
    <div style={{ display: "flex", justifyContent: "space-around", padding: 8 }}>
      <SortSelector
        label="Biden"
        icon={democratLogo}
        dir={sort.direction}
        enabled={sort.party === "democrat"}
        onClick={handleClick("democrat")}
      />
      <SortSelector
        label="Trump"
        icon={republicanLogo}
        dir={sort.direction}
        enabled={sort.party === "republican"}
        onClick={handleClick("republican")}
      />
    </div>
  )
}

export default SortBar
